export default __webpack_public_path__ + "static/media/metamask.91faa416.png";